import React, { useState } from 'react';
import Medicare from './Medicare/Medicare';
import Commercial from './Commercial/Commercial';
import Sidebar from '../../components/Sidebar/Sidebar';
import CommercialResult from './Commercial/CommercialResult';
import MedicareResult from './Medicare/MedicareResult';
import { IconCreditCardPay, IconInputSearch } from '@tabler/icons-react';

const sidebarItems = [
  {
    path: '/landing/coverage-verification',
    label: 'Coverage Verification',
    icon: <IconCreditCardPay size={24} />,
    matchSubpaths: false,
  },
  {
    path: '/landing/drug-search',
    label: 'Drug Search',
    icon: <IconInputSearch size={24} />,
    matchSubpaths: true, // This will match all subpaths
  },
];

function CoverageVerification() {
  // Define tabs as constants to avoid typos and make maintenance easier
  const TABS = {
    COMMERCIAL: 'commercial',
    MEDICARE: 'medicare',
    NONE: '',
  };

  const [activeTab, setActiveTab] = useState(TABS.NONE);
  const [commercialData, setCommercialData] = useState(null);
  const [medicareData, setMedicareData] = useState(null);

  // Check if any data is available
  const hasData = commercialData || medicareData;

  // Determine which result to show based on active tab
  const showCommercialResult = activeTab === TABS.COMMERCIAL && commercialData;
  const showMedicareResult = activeTab === TABS.MEDICARE && medicareData;

  function handleDataFromCommercial(data) {
    setCommercialData(data);
  }

  function handleDataFromMedicare(data) {
    setMedicareData(data);
  }

  function handleTabChange(tab) {
    setActiveTab(tab);
  }

  // Extract data safely using destructuring with default values
  const [
    commercialDrugInfo = null,
    commercialPlanInfo = null,
    drugName = null,
  ] = commercialData || [];

  const [
    medicareDrugInfo = null,
    medicarePlanInfo = null,
    drugTier = null,
    zipCode = null,
    medicareDrugName = null,
  ] = medicareData || [];

  // Render radio button tab
  const renderTabButton = (tab, label) => (
    <li className="nav-item" role="presentation">
      <button
        className={`nav-link ${activeTab === tab ? 'active' : ''}`}
        id={`pills-${tab}-tab`}
        onClick={() => handleTabChange(tab)}
        type="button"
        role="tab"
        aria-selected={activeTab === tab}
      >
        <div className="form-check cst-radio">
          <input
            className="form-check-input"
            type="radio"
            name="coverageType"
            id={`${tab}Radio`}
            checked={activeTab === tab}
            onChange={() => handleTabChange(tab)}
          />
          <label className="form-check-label" htmlFor={`${tab}Radio`}>
            {label}
          </label>
        </div>
      </button>
    </li>
  );

  return (
    <div className="">
      <div className={`fixed-container-${hasData ? 'left' : 'center pt-5'}`}>
        {/* {!hasData && <h1 className="Welcome-title">Welcome!</h1>} */}

        <div className={`d-flex ${hasData ? '' : 'gap-12'}`}>
          <Sidebar items={sidebarItems} />
          <div className={`coverage-container ${hasData ? 'gap-0' : ''}`}>
            <h4>Select Coverage Type</h4>
            <div className="cst-tabs">
              <ul
                className="nav nav-pills flex-row"
                id="pills-tab"
                role="tablist"
              >
                {renderTabButton(TABS.COMMERCIAL, 'Commercial')}
                {renderTabButton(TABS.MEDICARE, 'Medicare')}
              </ul>

              <div className="tab-content" id="pills-tabContent">
                <div
                  className={`tab-pane fade ${activeTab === TABS.COMMERCIAL ? 'show active' : ''}`}
                  id="pills-commercial"
                  role="tabpanel"
                  aria-labelledby="pills-commercial-tab"
                >
                  <Commercial
                    updateDataToCoverageVerification={handleDataFromCommercial}
                  />
                </div>
                <div
                  className={`tab-pane fade ${activeTab === TABS.MEDICARE ? 'show active' : ''}`}
                  id="pills-medicare"
                  role="tabpanel"
                  aria-labelledby="pills-medicare-tab"
                >
                  <Medicare
                    updateDataToCoverageVerification={handleDataFromMedicare}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="innerpage detailed-page">
        {showCommercialResult && (
          <CommercialResult
            commercialDrugInformation={commercialDrugInfo}
            commercialPlanInformation={commercialPlanInfo}
            drugName={drugName}
          />
        )}

        {showMedicareResult && (
          <MedicareResult
            medicareDrugInformation={medicareDrugInfo}
            medicarePlanInformation={medicarePlanInfo}
            drugTier={drugTier}
            zipCode={zipCode}
            drugName={medicareDrugName}
          />
        )}
      </div>
    </div>
  );
}

export default CoverageVerification;
